export default "__VITE_ASSET__BzxQiDE5__"